import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { usePagination, DOTS } from "../utils/usePagination";
import "./Pager.scss";

interface PagerProps {
  page: number;
  setPage: Function;
  pageSize: number;
  totalCount: number;
  siblingCount?: number;
}

const Pager: React.FC<PagerProps> = ({
  page,
  setPage,
  pageSize,
  totalCount,
  siblingCount = 1,
}) => {
  const paginationRange = usePagination({
    page,
    pageSize,
    totalCount,
    siblingCount,
  });

  // do not render Pager component if less than 2 pages
  if (paginationRange != undefined) {
    if (page < 0 || paginationRange.length < 2) {
      return null;
    }
  }
  let lastPage =
    paginationRange != undefined
      ? paginationRange[paginationRange.length - 1]
      : 0;

  const onNext = () => {
    setPage(page + 1);
  };

  const onPrevious = () => {
    setPage(page - 1);
  };

  return (
    <div className="mp-organisms-table-pager--main">
      {/* Previous Page Button */}
      <div
        className={`pager-button ${page > 0 && "show"}`}
        onClick={onPrevious}
      >
        {page > 0 && <FaChevronLeft className="page-arrows" />}
      </div>

      {/* Page Buttons */}
      {paginationRange?.map((pageNumber, index) => {
        return (
          <div
            className={`pager-button ${
              page === pageNumber && "selected"
            }  ${"show"}`}
            key={index}
            onClick={() =>
              typeof pageNumber === "number" ? setPage(pageNumber) : null
            }
          >
            {typeof pageNumber === "number" ? pageNumber + 1 : DOTS}
          </div>
        );
      })}

      {/* Next Page Button */}
      <div
        className={`pager-button ${page !== lastPage && "show"}`}
        onClick={onNext}
      >
        {page !== lastPage && <FaChevronRight className="page-arrows" />}
      </div>
    </div>
  );
};

export default Pager;
